import { render, staticRenderFns } from "./IdaBackTarifaEconomica.vue?vue&type=template&id=bce14522&scoped=true&"
import script from "./IdaBackTarifaEconomica.vue?vue&type=script&lang=js&"
export * from "./IdaBackTarifaEconomica.vue?vue&type=script&lang=js&"
import style0 from "./IdaBackTarifaEconomica.vue?vue&type=style&index=0&id=bce14522&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bce14522",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VCol,VContainer,VDivider,VIcon,VRow,VTooltip})
